export default __webpack_public_path__ + "static/csm-7be5f196ee3e833d21235bf93007ff75.png";